import GalleryManager from "./GalleryManager";

export default function CookiePersoGalleryManager() {
    return (
        <GalleryManager
            endpoint="/admin/cookie-perso-gallery"
            title="Galerie Cookies personnalisés"
            description="Téléverse les photos de tes créations sur-mesure (baby showers, mariages, anniversaires…). Elles s'afficheront en bas de l'onglet Cookies personnalisés sur la page Commander."
            testidPrefix="cookie-perso-gallery"
            itemLabel="cookie personnalisé"
        />
    );
}
